/**
  Movieplayer Awards
*/

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	startDate = new Date("2026-01-08T00:00:00");
	endDate = new Date("2026-01-16T23:59:59");
	todayDate = new Date();
	if (
		todayDate >= startDate &&
		todayDate <= endDate &&
		!!document.querySelector("#_movie_awards")
	) {
		document.querySelector("#_movie_awards").classList.remove("d-none");
	}
});
